import { FC, memo } from 'react'
import { useMemo } from 'react'
import { useTranslation } from '@crew/modules/i18n'
import { CrewTabProps } from 'components/elements/crewTabs/components/crewTab'
import { CrewTabs } from 'components/elements/crewTabs/crewTabs'

// タブ定義
export const ChatStartTabs = {
  // ユーザータブ
  User: {
    id: 'chat-start-tab-user',
    text: 'label.user',
  },
  // グループタブ
  Group: {
    id: 'chat-start-tab-group',
    text: 'label.group',
  },
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ChatStartTabs = (typeof ChatStartTabs)[keyof typeof ChatStartTabs]

export type ChatStartTabProps = {
  selectedId: string
  tabsSelectionChanged: (selectedId: string) => void
}

// チャット開始ダイアログのタブ
export const ChatStartTab: FC<ChatStartTabProps> = memo((props) => {
  const { t } = useTranslation()

  // タブアイテム
  const displayTabItems: CrewTabProps[] = useMemo(() => {
    const items = Object.values(ChatStartTabs).map((item) => {
      return {
        id: item.id,
        onClick: () => {
          // 選択タブを更新
          props.tabsSelectionChanged(item.id)
        },
        selected: props.selectedId === item.id,
        text: t(item.text),
      }
    })

    return items
  }, [props, t])

  return <CrewTabs tabItems={displayTabItems} />
})
